import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom"; // Import Link for navigation
import logo from "../assets/images/cropped_circle_image.png";
import { FaFacebook, FaInstagram, FaTiktok, FaTelegram, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const CustomFooter = () => {
  const { t } = useTranslation();
  return (
    <footer className="footer mt-5" style={{ fontFamily: "'Hanuman', Arial, sans-serif" }}>
      <Container fluid className="px-5 p-no space-top-custom">
        <Row className="">
          <Col
            xs={4}
            className="d-flex justify-content-start align-items-start flex-column ps-3 ps-md-5 mt-4"
          >
            <div className="footer-logo">
              <Link to="/home" className="text-decoration-none text-white">
                <img src={logo} alt="logo" className="logo-img shadow-lg" />
              </Link>
            </div>
            <div className=" m-no">
              <p className="footer-text">
               {t('long_footer_text')}
              </p>
            </div>
            <div className="social-media-icons ps-3 ps-md-0">
              <a
                href="https://www.facebook.com/profile.php?id=100069338837090"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook className="social-icon" />
              </a>
              <a
                href="https://www.instagram.com/ptes_pet_tmenh?igsh=MTFma3MxcTJpaHJwcQ%3D%3D&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram className="social-icon" />
              </a>
              <a
                href="https://www.tiktok.com/@ptespettmenh?_t=ZS-8wpual8LsHa&_r=1"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTiktok className="social-icon" />
              </a>
            </div>
          </Col>
          <Col
            xs={4}
            className="d-flex mt-3 pt-3 justify-content-center align-items-start"
          >
            <div className="navigation-section">
              <h5 className="navigation-title text-white"> {t('Navigation')} </h5>
              <div className="footer-line-style"></div>
              <ul className="footer-navigation-links mt-4">
                <li className="my-3">
                  <Link to="/" className="link">{t('HOME')}</Link>
                </li>
                <li className="mb-3">
                  <Link to="/shop" className="link">{t('SHOP')}</Link>
                </li>
                <li className="mb-3">
                  <Link to="/promotion" className="link"> {t('PROMOTIONS')} </Link>
                </li>
                <li className="mb-3">
                  <Link to="/blogs" className="link">{t('BLOG')}</Link>
                </li>
                <li className="mb-3">
                  <Link to="/contact" className="link"> {t('CONTACT')} </Link>
                </li>
              </ul>
            </div>
          </Col>
          <Col
            xs={4}
            className=" mt-3 pt-3 d-flex justify-content-center align-items-start navigation-section"
          >
            <div className="navigation-section contact">
              <div>
                <h5 className="navigation-title text-white">{t('Contact Info')}</h5>
                <div className="footer-line-style"></div>
              </div>
              <div className="mt-4">
                {/* Contact Information with Icons */}
                <div className="d-flex align-items-center mb-3">
                  <FaTelegram className="me-1 fs-5 icon-footer" style={{ color: "#ded3c1" }} />
                  <p className="mb-0 ms-2 navigation-text">
                    <span>
                      <a href="https://t.me/kroobscent_admin" target="_blank" rel="noopener noreferrer" className="text-primary">Kroop Scent</a>
                    </span>
                  </p>
                </div>
                <div className="d-flex align-items-center mb-3">
                  <FaEnvelope className="me-1 fs-5 icon-footer" style={{ color: "#ded3c1" }} />
                  <p className="mb-0 ms-2 navigation-text text-white"> kroobscent@gmail.com</p>
                </div>
                <div className="d-flex align-items-center mb-4">
                  <FaMapMarkerAlt className=" fs-5 icon-footer" style={{ color: "#ded3c1" }} />
                  <p className="mb-0 ms-2 navigation-text d-flex-custom">
                    <a
                      href="https://maps.app.goo.gl/wWZy2WX7asUQNGdg7?g_st=ic"
                      className="text-primary cursor-pointer text-decoration-none"
                    >
                      <span className="text-color-link ms-1">{t('View on Google Maps')}</span>
                    </a>
                  </p>
                </div>

                {/* Feedback Input with Icon */}
                <div className="input-icon-container position-relative">
                  <input
                    type="text"
                    placeholder={t("Sent feedback")}
                    className="form-control border-0 rounded-5 px-md-5 px-4 py-2"
                    style={{
                      backgroundColor: "#f8f9fa", // Light background for the input
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", // Subtle shadow
                    }}
                  />
                  <FaTelegram
                    className="input-icon fs-3 cursor-pointer"
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#1096d0",
                      transition: "color 0.3s ease", // Smooth hover effect
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#1096d0")} // Darker color on hover
                    onMouseLeave={(e) => (e.target.style.color = "#1096d0")}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default CustomFooter;
